import { apiFetch } from './apiClient';

export type ExecutionRecord = {
  id: number; createdAt: string; projectId: string|null; projectName: string|null;
  actionId: string|null; actionName: string|null; method: string; sanitizedUrl: string;
  status: number|null; durationMs: number; outcome: string; errorCode: string|null;
  errorMessage: string|null; preview: string|null; responseBytes: number|null;
  previewTruncated: number; contentType: string|null;
};

export async function listExecutions(filters: {actionId?:string;outcome?:string;status?:string} = {}): Promise<ExecutionRecord[]> {
  const query=new URLSearchParams(); Object.entries(filters).forEach(([key,value]) => { if(value) query.set(key,value); });
  const response=await apiFetch(`/api/executions?${query}`); if(!response.ok) throw new Error('Could not load execution history.');
  return ((await response.json()) as {executions:ExecutionRecord[]}).executions;
}
export async function clearExecutions(): Promise<void> { const response=await apiFetch('/api/executions',{method:'DELETE'}); if(!response.ok) throw new Error('Could not clear execution history.'); }
